export default __webpack_public_path__ + "assets/images/1c7af94828140e4ba2ab9a324250a114.png";